module.exports = __webpack_public_path__ + "static/pork_king-875502ae9c236d0af68551f9122a3d8f.jpg";